import { createAction, createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { LoadOrganizationBillingReportProps, OrganizationBillingReportGridParams, ReduxOrganizationsBillingReportSearchState, ViewOrganizationBillingReportProps, ViewOrganizationActivityReportProps  } from "../types";
import { ReduxSliceState } from "../../../shared/types";
import { OrganizationItem, UserItem, OrganizationBillingReport, OrganizationActivityReport } from "../../../api/types";
import { ReduxRootState } from "../../../shared/redux/store";
import { withPayloadType } from "../../../shared/utils";

const initialState: ReduxOrganizationsBillingReportSearchState = {
    state: 'BUSY',
    prevPage: undefined,
    nextPage: undefined,
    organizationBillingReports: [],
    reportContent: undefined,
    selectedOrgBillingReport: undefined,
    selectedOrgBillingReportRowIndex: undefined,
    organizationActivityReports: [],
    selectedOrgActivityReport: undefined,
    selectedOrgActivityReportRowIndex: undefined,
};

export const loadOrganizationBillingReports = createAction('organizationbillingreports/search/loadOrganizationBillingReports', withPayloadType<string | number | undefined>());
export const viewOrganizationBillingReport = createAction('organizationbillingreports/search/viewOrganizationBillingReport', withPayloadType<ViewOrganizationBillingReportProps>());
export const loadOrganizationBillingReportContent = createAction('organizationbillingreports/search/loadOrganizationBillingReportContent', withPayloadType<ViewOrganizationBillingReportProps>());

export const loadOrganizationActivityReports = createAction('organizationbillingreports/search/loadOrganizationActivityReports', withPayloadType<string | number | undefined>());
export const viewOrganizationActivityReport = createAction('organizationbillingreports/search/viewOrganizationActivityReport', withPayloadType<ViewOrganizationActivityReportProps>());
export const loadOrganizationActivityReportContent = createAction('organizationbillingreports/search/loadOrganizationActivityReportContent', withPayloadType<ViewOrganizationActivityReportProps>());

export const organizationBillingReportsSearchSlice = createSlice({
    name: 'organizationbillingreports/search',
    initialState,
    reducers: {
        setState: (state, action: PayloadAction<ReduxSliceState>) => {
            state.state = action.payload;
        },
        setSelectedOrgBillingReportRowIndex: (state, action: PayloadAction<number | undefined>) => {
            state.selectedOrgBillingReportRowIndex = action.payload;
        },
        setOrganizationBillingReports: (state, action: PayloadAction<OrganizationBillingReport[]>) => {
            state.organizationBillingReports = action.payload;
        },
        setSelectedOrganizationBillingReport: (state, action: PayloadAction<OrganizationBillingReport | undefined>) => {
            return {
                ...state,
                selectedOrgBillingReport: action.payload,
            };
        },
        setSelectedOrgActivityReportRowIndex: (state, action: PayloadAction<number | undefined>) => {
            state.selectedOrgActivityReportRowIndex = action.payload;
        },
        setOrganizationActivityReports: (state, action: PayloadAction<OrganizationActivityReport[]>) => {
            state.organizationActivityReports = action.payload;
        },
        setSelectedOrganizationActivityReport: (state, action: PayloadAction<OrganizationActivityReport | undefined>) => {
            return {
                ...state,
                selectedOrgActivityReport: action.payload,
            };
        },
        setReportContent: (state, action: PayloadAction<string | undefined>) => {
            state.reportContent = action.payload;
        },
    }
});

const selectSelf = (state: ReduxRootState) => state.organizationBillingReportsSearch;
export const selectOrganizationBillingReportsSearchIsBusy = createSelector(selectSelf, self => self.state === 'BUSY');
export const selectOrganizationBillingReportsSearchState = createSelector(selectSelf, self => self.state);
export const selectOrganizationBillingReportsSearchPageBusy = createSelector(selectOrganizationBillingReportsSearchState, state => state === 'BUSY');
export const selectOrganizationBillingReportsSearchSelectedReports = createSelector(selectSelf, self => self.organizationBillingReports);
export const selectOrgBillingReportsSearchSelectedReport = createSelector(selectSelf, self => self.selectedOrgBillingReport);
export const selectOrgBillingReportsSearchSelectedViewFile = createSelector(selectSelf, self => self.reportContent);
export const selectOrgBillingReportsSearchSelectedReportRowIndex = createSelector(selectSelf, self => self.selectedOrgBillingReportRowIndex);
export const selectOrganizationActivityReportsSearchSelectedReports = createSelector(selectSelf, self => self.organizationActivityReports);
export const selectOrgActivityReportsSearchSelectedReport = createSelector(selectSelf, self => self.selectedOrgActivityReport);
export const selectOrgActivityReportsSearchSelectedViewFile = createSelector(selectSelf, self => self.reportContent);
export const selectOrgActivityReportsSearchSelectedReportRowIndex = createSelector(selectSelf, self => self.selectedOrgActivityReportRowIndex);
export default organizationBillingReportsSearchSlice;
